(ns hypnos.sleeplab.app
  "The SleepLab application."
  (:require ["aws-amplify-react" :refer (
                                         ConfirmSignIn
                                         ;; ConfirmSignUp
                                         ForgotPassword
                                         RequireNewPassword
                                         SignIn
                                         ;; SignUp
                                         VerifyContact
                                         withAuthenticator)]
            [hypnos.graphql.queries :as queries]
            [hypnos.sleeplab.bar.aside :as aside]
            [hypnos.sleeplab.bar.footer :as footer]
            [hypnos.sleeplab.bar.navigation :as nav]
            [hypnos.sleeplab.bar.title :as title]
            [hypnos.sleeplab.panel.dashboard :as dashboard]
            [hypnos.sleeplab.panel.error :as error]
            [hypnos.sleeplab.panel.patient :as patient]
            [hypnos.sleeplab.panel.patients :as patients]
            [re-frame.core :as rf]
            [reagent.core :as reagent]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Helpers

(defn- panels
  [panel]
  (case (:name panel)
    ;; external
    :dashboard-panel [dashboard/panel]
    :patient-panel   [patient/panel (:params panel)]
    :patients-panel  [patients/panel]
    [:div]))

(defn- container
  []
  (let [_ (rf/dispatch-sync [:amplify/get-auth-session :sleeplab/set-session :sleeplab/set-error])
        _ (rf/dispatch-sync [:amplify/query queries/get-user {} :sleeplab/set-user :sleeplab/set-error])
        _ (rf/dispatch [:amplify/query queries/get-catalog {} :sleeplab/set-catalog :sleeplab/set-error])]
    (fn []
      (let [active-panel (rf/subscribe [:sleeplab/active-panel])]
        [:div
         [nav/bar]
         [aside/primary]
         [aside/secondary]
         [title/bar]
         [error/panel]
         [panels @active-panel]
         [footer/bar]]))))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;; API

(def app
  (reagent/adapt-react-class
   (withAuthenticator
    (reagent/reactify-component container)
    false
    #js [(reagent/create-element SignIn)
         (reagent/create-element ConfirmSignIn)
         (reagent/create-element VerifyContact)
         (reagent/create-element RequireNewPassword)
         (reagent/create-element ForgotPassword)])))
